/**
 * @prettier
 */

import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

import CustomButton from "../../../components/CustomButton";
import Header from "../../../components/Header";
import SubmissionFlowStepper from "../../../components/SubmissionFlowStepper";
import PortraitOrientationGate from "./PortraitOrientationGate";
import { usePortraitOrientationGate } from "./usePortraitOrientationGate";

const IDPalCameraCapture = ({
    flashCamera,
    getDimensions,
    isTwoPagePassport = false,
    primaryFocusRef,
    scrollToRef,
}) => {
    const { t } = useTranslation();
    const isTwoPage = isTwoPagePassport();
    const showPortraitGate = usePortraitOrientationGate(isTwoPage);

    useLayoutEffect(() => {
        if (!isTwoPage) {
            return;
        }

        const el = scrollToRef?.current;
        if (!el) {
            return;
        }

        const top = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: Math.max(0, top),
            behavior: "smooth",
        });
    }, [isTwoPage, scrollToRef]);

    return (
        <>
            <PortraitOrientationGate show={showPortraitGate} />
            <div>
                <div className="root-layout-container id-pal-overlay">
                    <Header />
                    {!isTwoPage && <SubmissionFlowStepper />}
                    <h1
                        ref={primaryFocusRef}
                        className="id-pal-overlay-title"
                        tabIndex={-1}
                    >
                        {isTwoPage
                            ? t("idpal_two_page_passport_instructions")
                            : t("idpal_one_page_passport_instructions")}
                    </h1>
                </div>

                <div
                    className={
                        isTwoPage
                            ? "capture-content vertical"
                            : "capture-content"
                    }
                >
                    <div className="content-capture" ref={scrollToRef}>
                        <div className="canvas-container">
                            <div className="capture-brackets" />
                            {isTwoPage && <div className="capture-guide" />}
                            <video
                                id="my-video"
                                controls
                                autoPlay
                                playsInline
                                style={{ display: "none" }}
                            >
                                <track kind="captions" />
                            </video>
                            <canvas
                                id="my-canvas"
                                height={getDimensions().height}
                                width={getDimensions().width}
                            ></canvas>
                        </div>
                    </div>
                </div>
                <div className="root-layout-container cta-button-container">
                    <CustomButton
                        handleClick={() => flashCamera()}
                        actionDataLabel={"Id-pal-capture"}
                        label={t("idpal_capture_capitalize")}
                        isDisabled={showPortraitGate}
                    />
                </div>
            </div>
        </>
    );
};
export default IDPalCameraCapture;
